import apiService from '@/utils/api-client'
import config from "@/utils/appConfig";
import router from "@/router";

export default {
  // eslint-disable-next-line no-unused-vars
  login({ commit }, { email, password }) {
    try {
      return apiService.post('users/login', { email, password }, { baseURL: config.VUE_APP_API_USERS_URL })
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  verifyMfaCode({ commit }, { otpId, code }) {
    return apiService.post(
      'users/mfa/verify',
      { otpId, code },
      { baseURL: config.VUE_APP_API_USERS_URL }
    )
  },
  // eslint-disable-next-line no-unused-vars
  resendMfaCode({ commit }, { otpId }) {
    return apiService.post(
      'users/mfa/resend',
      { otpId },
      { baseURL: config.VUE_APP_API_USERS_URL }
    )
  },
  // eslint-disable-next-line no-unused-vars
  setScoringFormula({ commit }, { formula }) {
    try {
      return apiService.patch('user-params/updateParams', { formula }, { baseURL: config.VUE_APP_API_USERS_URL })
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  setFiat({ commit }, { preferredCurrency }) {
    try {
      return apiService.patch('user-params/updateParams', { currencyCode: preferredCurrency }, { baseURL: config.VUE_APP_API_USERS_URL })
    } catch (error) {
      console.error(error)
    }
  },
  // eslint-disable-next-line no-unused-vars
  createApiKey({ commit }) {
    try {
      return apiService.post('users/create-api-key', {}, { baseURL: config.VUE_APP_API_USERS_URL })
    } catch (error) {
      console.error(error)
    }
  },
  setNotifications(cntx, { emailAlertsEnabled }) {
    try {
      return apiService.patch('user-params/updateParams', { emailAlertsEnabled }, { baseURL: config.VUE_APP_API_USERS_URL })
    } catch (error) {
      console.error(error)
    }
  },
  async logout({ commit }) {
    try {
      if (localStorage.getItem('token')) {
        await apiService.post('users/logout', {}, { baseURL: config.VUE_APP_API_USERS_URL })
      }
    } catch (error) {
      console.error(error)
    } finally {
      commit('REMOVE_USER_TOKEN')
      commit('REMOVE_USER_REFRESH_TOKEN')
      commit('REMOVE_USER_ID')
      commit('REMOVE_USER_API_KEY_DATA')
    }
  },
  register({ commit }, { email, password, invitationCode }) {
    return apiService.post(
      'users/register',
      { email, password, invitationCode },
      { baseURL: config.VUE_APP_API_USERS_URL }
    )
      .then(({ data, success }) => {
        commit('SET_USER_TOKEN', data)
        commit('SET_USER_ID', data)
        return { data, success }
      })
      .catch(error => {
        console.error(error)
        return { data: error.response?.data, success: false }
      })
  }
  ,
  resetPassword({ commit }, { email, password, resetToken }) {
    return apiService.post('users/update-password', { email, password, resetToken }, { baseURL: config.VUE_APP_API_USERS_URL })
      .then(({ data }) => {
        commit('SET_USER_TOKEN', data)
        commit('SET_USER_ID', data) })
  },
  getMe({ commit }) {
    return apiService.get(`users/me`, { baseURL: config.VUE_APP_API_USERS_URL })
      .then(({ data }) => {
        commit('SET_USER_DATA', data)})
      .catch(() => {
        return true
      })
  },
  getApiKey({ commit }) {
    return apiService.get(`users/me/api-key`, { baseURL: config.VUE_APP_API_USERS_URL })
      .then(({ data }) => {
        commit('SET_USER_API_KEY_DATA', data)
        return data
      })
      .catch(() => true)
  },
  resetToken({ commit }, { refreshToken }) {
    return apiService.get(`users/reset-token/${refreshToken}`, { baseURL: config.VUE_APP_API_USERS_URL })
        .then(({ data }) => {
          if (data && data.token) {
            commit('SET_USER_TOKEN', data)
            commit('SET_USER_REFRESH_TOKEN', data)
            commit('SET_USER_ID', data)
            return true
          } else {
            if (router.currentRoute.name !== 'login') {
              localStorage.setItem('lastRoute', router.currentRoute.name)
            }
            this.logout()
            window.location.assign('/login')
          }
        })
  },
  initToken({ commit }) {
    const token = localStorage.getItem('token')
    if (token) commit('SET_USER_TOKEN', { token })
    return token;
  },
}
